/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable security-node/detect-crlf */
import { useEffect } from 'react'
import { Image, Text, VStack } from '@chakra-ui/react'
import logo from 'assets/lottie/loader_wicar.gif'
import { useAuth } from 'context'
import { AuthExternalBody } from 'context/Auth/authTypes'

import { customToast } from 'components/ToastCustom'

export const ExternalPaymentGateway = () => {
  const { externalLogin, clearError, authState: { error } } = useAuth()

  useEffect(() => {
    error && customToast.showToast({ description: error })
    clearError()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  const handleExternalLogin = async (data: AuthExternalBody)  => {
    await externalLogin(data)
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const accessToken = queryParams.get('accesstoken')
    const refreshToken = queryParams.get('refreshtoken')
    const paymentgateway = queryParams.get('paymentgateway')

     if(accessToken && refreshToken && paymentgateway)
        handleExternalLogin({ accessToken ,refreshToken,paymentgateway })
    // http://localhost:3000/external-payment-gateway?refreshtoken=YAYAYAYAYAf&accesstoken=TOKEN&paymentgateway=https://mipago.kaufmann.cl/pasarelapago/
  },[])


  return (
    <VStack
      w={'full'}
      h={'100vh'}
      alignItems={'center'}
      justifyContent={'center'}
      justifyItems={'center'}
      >
      <Image
        w={'120px'}
        h={'120px'}
        alt={'loading_wicar'}
        src={logo}
      />
      <Text>{'Cargando pasarela de pago ... '}</Text>
    </VStack>
  )
}
